<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">{{ title }}</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <div class="grid grid-cols-2 gap-4">
                  <!-- Divider do Proponente -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Dados do Proponente {{ proposta?.dependente?.nome || proposta?.segurado?.nome || '' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Proponente</label>
                    <input :value="proposta?.dependente?.nome || proposta?.segurado?.nome || ''" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Estado Civil</label>
                    <input :value="proposta?.proponente_estado_civil" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Sexo</label>
                      <input :value="proposta?.proponente_sexo" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                    </div>
                    
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Filhos</label>
                      <input :value="proposta?.proponente_filhos" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                    </div>
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Data de Admissão</label>
                    <input :value="proposta?.proponente_admissao" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Salário</label>
                    <input :value="proposta?.proponente_salario" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nacionalidade</label>
                    <input :value="proposta?.proponente_nacionalidade" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">E-mail do Consultor</label>
                    <input :value="proposta?.consultor_email || proposta?.ficha?.consultor_email || '—'" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 font-semibold text-blue-800 focus:ring-0 focus:border-blue-400"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">E-mail do Agendador</label>
                    <input :value="proposta?.agendador_email || proposta?.ficha?.lista_de_agendamento?.agendador_email || '—'" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 font-semibold text-indigo-800 focus:ring-0 focus:border-blue-400"/>
                  </div>
                <!-- Divider Apolices -->
                  <div v-if="!isOnlyConsultor" class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Apolices
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="!isOnlyConsultor" class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label for="apolice_search" class="block text-sm font-medium leading-6 text-gray-900">
                      Apólice
                    </label>

                    <input
                      id="apolice_search"
                      type="text"
                      v-model="apoliceQuery"
                      @input="onSearchApolice"
                      autocomplete="off"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Digite pelo menos 4 letras..."
                    />

                    <!-- Lista simples -->
                    <div
                      v-if="apoliceQuery?.trim()?.length >= 4 && apoliceResults.length"
                      class="mt-2 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 bg-white overflow-hidden"
                    >
                      <button
                        v-for="item in apoliceResults"
                        :key="item.id"
                        type="button"
                        @click="selectApolice(item)"
                        class="w-full text-left px-3 py-2 text-sm text-gray-900 hover:bg-gray-50"
                      >
                        {{ item.nome || item.numero || item.id }}
                      </button>
                    </div>
                    <p
                      v-else-if="apoliceQuery?.trim()?.length >= 4 && !apoliceResults.length"
                      class="mt-2 text-xs text-gray-500"
                    >
                      Nenhuma apólice encontrada.
                    </p>
                    <!-- ID real selecionado -->
                    <input type="hidden" v-model="data.apolice_id" />
                  </div>
                 <div class="col-span-2">
                    <div class="rounded-lg border border-gray-200 bg-white shadow-sm p-4">
                      <div class="flex items-center justify-between mb-4">
                        <h3 class="text-sm font-semibold text-gray-900">Ações</h3>
                        <span class="text-xs text-gray-500">Proposta / Documentos</span>
                      </div>

                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <!-- Gestão da Proposta -->
                        <div class="rounded-md border border-gray-100 bg-gray-50 p-3">
                          <p class="text-xs font-semibold text-gray-700 mb-2">Gestão da Proposta</p>

                          <div class="flex flex-col gap-2">
                            <button
                              @click="openSolicitacao('criar')"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Solicitação
                            </button>

                            <button
                              @click="modalDocumentoAberto = true"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Enviar Arquivos
                            </button>

                            <button
                              v-if="!isOnlyConsultor"
                              @click="abrirModalVincularApolice"
                              type="button"
                              class="bg-indigo-600 text-white text-sm px-4 py-1.5 rounded-md hover:bg-indigo-700 text-left font-medium"
                            >
                              Criar Apólice / Vincular Segurado
                            </button>
                          </div>
                        </div>

                        <!-- Assinatura & Documentos -->
                        <div v-if="!isOnlyConsultor" class="rounded-md border border-gray-100 bg-gray-50 p-3">
                          <p class="text-xs font-semibold text-gray-700 mb-2">Assinatura & Documentos</p>

                          <div class="flex flex-col gap-2">
                            <button
                              @click="gerarDocumento"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Gerar Documento para Assinatura
                            </button>

                            <button
                              @click="notificar"
                              type="button"
                              class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue text-left"
                            >
                              Enviar para assinatura
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Divider Solicitações -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                         Solicitações
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div class="max-h-72 overflow-y-auto">
                      <SolicistacoesList
                        :solicitacoes="proposta.solicitacao"
                        @handle-request="handleRequest"
                        @cancel-request="handleRequest"
                      />
                    </div>
                  </div>
                  <!-- Divider de linha temporal-->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Linha Temporal da Proposta
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                      <PropostaTimeline
                        :timeline="proposta.timeline"
                      />   
                  </div>
                  <!-- Divider de linha temporal-->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Documentos Solicitados
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                      <PropostaDocumentosPersonalizados
                        :docs="proposta.docs"
                      />   
                  </div>
                  <!-- Divider Dados de Endereço -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Dados de Endereço
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
                    <input :value="proposta?.proponente_endereco" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Bairro</label>
                    <input :value="proposta?.proponente_bairro" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
                    <input :value="proposta?.proponente_cidade" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <!-- Divider Dados Financeiros e Plano -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Plano e Pagamento
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Plano</label>
                    <input :value="proposta?.plano?.nome" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Empresa</label>
                    <input :value="proposta?.plano?.empresa_nome" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Forma de Pagamento</label>
                      <input :value="proposta?.forma_pagamento" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Periodicidade</label>
                      <input :value="proposta?.periodicidade_pagamento" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Capital</label>
                      <input :value="proposta?.capital" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Prêmio Líquido</label>
                      <input :value="proposta?.premio_liquido" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">IOF</label>
                      <input :value="proposta?.valor_iof" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Prêmio Total</label>
                      <input :value="proposta?.premio_total" readonly class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm"/>
                    </div>
                  </div>
                  <!-- Divider Beneficiários -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Beneficiários
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div v-if="proposta?.beneficiarios?.length" class="space-y-4 mt-4">
                      <div
                        v-for="(beneficiario, index) in proposta.beneficiarios"
                        :key="index"
                        class="bg-gray-50 p-4 rounded-lg shadow-md"
                      >
                        <p><strong>Nome:</strong> {{ beneficiario.nome }}</p>
                        <p><strong>CPF:</strong> {{ beneficiario.cpf }}</p>
                        <p><strong>Parentesco:</strong> {{ beneficiario.grau_parentesco }}</p>
                        <p><strong>Participação (%):</strong> {{ beneficiario.percentual_participacao }}</p>
                      </div>
                    </div>
                  </div>

                  <div v-for="(grupo, gIndex) in proposta.perguntas" :key="gIndex" class="col-span-2">
                    <!-- Divider com nome do grupo -->
                    <div class="col-span-2 mt-10 mb-5">
                      <div class="relative">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-start">
                          <span class="bg-white px-2 font-semibold text-blue-700">
                            {{ grupo.grupo }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Bloco de perguntas -->
                    <div
                      class="w-full p-4 bg-white rounded-lg shadow-md border border-gray-200 grid grid-cols-2 gap-6 col-span-2"
                    >
                      <div
                        v-for="(pergunta, pIndex) in grupo.perguntas"
                        :key="pIndex"
                        class="space-y-2"
                      >
                        <!-- Pergunta -->
                        <p class="font-medium text-gray-700">
                          {{ pergunta.pergunta }}
                        </p>

                        <!-- Respostas -->
                        <div v-for="(resp, rIndex) in pergunta.respostas" :key="rIndex" class="flex items-center space-x-2">
                          <span v-if="resp.subgrupo" class="text-sm text-gray-500 min-w-[100px]">
                            {{ resp.subgrupo }}:
                          </span>

                          <template v-if="pergunta.tipo === 'valor'">
                            <span class="text-gray-800">{{ resp.resposta ?? '-' }}</span>
                          </template>

                          <template v-else-if="pergunta.tipo === 'checkbox_sim'">
                            <input
                              type="checkbox"
                              class="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed"
                              :checked="resp.resposta"
                              disabled
                            />
                          </template>

                          <template v-else-if="pergunta.tipo === 'checkbox_sim_nao'">
                            <div class="flex items-center space-x-4">
                              <label class="flex items-center space-x-1">
                                <input
                                  type="checkbox"
                                  class="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed"
                                  :checked="resp.resposta.sim"
                                  disabled
                                />
                                <span class="text-sm">Sim</span>
                              </label>
                              <label class="flex items-center space-x-1">
                                <input
                                  type="checkbox"
                                  class="h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed"
                                  :checked="resp.resposta.nao"
                                  disabled
                                />
                                <span class="text-sm">Não</span>
                              </label>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Divider Status documento -->
                  <div class="col-span-2 mt-10 mb-5">
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="w-full border-t border-gray-300"></div>
                      </div>
                      <div class="relative flex justify-start">
                        <span class="bg-white px-2 font-semibold text-blue-700">
                          Status do Documento para assinatura
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full p-4 bg-white rounded-lg shadow-md border border-gray-200 space-y-2 col-span-2">

                    <p><strong>Status: </strong>
                      <span
                        :class="{
                          'text-yellow-600': proposta?.documento_clicksign?.status === 'running',
                          'text-green-600': proposta?.documento_clicksign?.status === 'signed',
                          'text-red-600': proposta?.documento_clicksign?.status === 'refused',
                          'text-gray-600': !proposta?.documento_clicksign?.status
                        }"
                      >
                        {{ proposta?.documento_clicksign?.status || 'Indefinido' }}
                      </span>
                    </p>

                    <p><strong>Envelope ID:</strong> {{ proposta?.documento_clicksign?.envelope_id }}</p>
                    <p><strong>Document ID:</strong> {{ proposta?.documento_clicksign?.document_id }}</p>
                    <p><strong>Signer ID:</strong> {{ proposta?.documento_clicksign?.signer_id }}</p>

                    <a
                      v-if="proposta?.documento_clicksign?.clicksign_document_url"
                      :href="proposta.documento_clicksign.clicksign_document_url"
                      target="_blank"
                      class="inline-block mt-2 text-sm text-blue-600 hover:underline"
                    >
                      Visualizar Documento
                    </a>
                  </div>
                </div>
                <SolicitacaoForm
                  :tipoFormSolicitacao="tipoFormSolicitacao"
                  :proposta="proposta"
                  :open="solicitacaoOpen"
                  @create-new-request="createResquest"
                  @create-new-response="createResponse"
                  @cancel-request="cancelRequest"
                  @close="solicitacaoOpen = false"
                  @update-open="solicitacaoOpen = false"
                />
                <PropostaDocumentoUpload
                  :open="modalDocumentoAberto"
                  @upload-documento="enviarDocumentoProposta"
                  @update-open="modalDocumentoAberto = $event"
                />

                <!-- MODAL VINCULAR APÓLICE / SEGURADO -->
                <TransitionRoot as="template" :show="modalVincularAberto">
                  <Dialog class="relative z-50" @close="modalVincularAberto = false">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </TransitionChild>

                    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                          <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-6 pb-6 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                            <div class="flex justify-between items-center pb-3 border-b">
                              <h3 class="text-lg font-bold text-gray-900">Vincular Apólice ao Segurado</h3>
                              <button @click="modalVincularAberto = false" type="button" class="text-gray-400 hover:text-gray-600">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            </div>

                            <div class="mt-4 space-y-4">
                              <div class="bg-blue-50 p-3 rounded-md border border-blue-100">
                                <p class="text-xs text-blue-800 font-semibold">Proponente: {{ proposta?.dependente?.nome || proposta?.segurado?.nome || 'Segurado em Processamento' }}</p>
                                <p v-if="proposta?.dependente_id" class="text-xs text-blue-600 mt-1">Tipo de Vínculo: Dependente</p>
                                <p v-else class="text-xs text-blue-600 mt-1">Tipo de Vínculo: Titular</p>
                              </div>

                              <!-- Toggle & Dados do Dependente -->
                              <div class="bg-gray-50 p-3 rounded-md border border-gray-200">
                                <label class="flex items-center space-x-2 text-xs font-semibold text-gray-800 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    v-model="formVinculo.is_dependente"
                                    @change="formVinculo.tipo_vinculo = formVinculo.is_dependente ? 1 : 0"
                                    class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                  />
                                  <span>Vincular Apólice como Dependente?</span>
                                </label>

                                <div v-if="formVinculo.is_dependente" class="mt-3 space-y-3 pt-3 border-t border-gray-200">
                                  <p class="text-xs text-indigo-700 font-semibold">Dados do Dependente (O sistema buscará se já existe ou criará automaticamente):</p>
                                  
                                  <div class="grid grid-cols-2 gap-3">
                                    <div>
                                      <label class="block text-xs font-medium text-gray-700">Nome do Dependente *</label>
                                      <input
                                        type="text"
                                        v-model="formVinculo.dependente_nome"
                                        class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-2 text-xs focus:border-indigo-500"
                                        placeholder="Nome completo"
                                      />
                                    </div>
                                    <div>
                                      <label class="block text-xs font-medium text-gray-700">CPF do Dependente</label>
                                      <input
                                        type="text"
                                        v-model="formVinculo.dependente_cpf"
                                        class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-2 text-xs focus:border-indigo-500"
                                        placeholder="000.000.000-00"
                                      />
                                    </div>
                                  </div>

                                  <div class="grid grid-cols-3 gap-2">
                                    <div>
                                      <label class="block text-xs font-medium text-gray-700">Data Nasc.</label>
                                      <input
                                        type="date"
                                        v-model="formVinculo.dependente_data_nascimento"
                                        class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-2 text-xs focus:border-indigo-500"
                                      />
                                    </div>
                                    <div>
                                      <label class="block text-xs font-medium text-gray-700">RG</label>
                                      <input
                                        type="text"
                                        v-model="formVinculo.dependente_rg"
                                        class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-2 text-xs focus:border-indigo-500"
                                        placeholder="RG"
                                      />
                                    </div>
                                    <div>
                                      <label class="block text-xs font-medium text-gray-700">Profissão</label>
                                      <input
                                        type="text"
                                        v-model="formVinculo.dependente_carreira"
                                        class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-2 text-xs focus:border-indigo-500"
                                        placeholder="Carreira/Ocupação"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Apólice Search / Select -->
                              <div>
                                <label class="block text-sm font-medium text-gray-700">Buscar / Selecionar Apólice *</label>
                                <input
                                  type="text"
                                  v-model="apoliceVinculoQuery"
                                  @input="onSearchApoliceVinculo"
                                  class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-3 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                                  placeholder="Digite pelo menos 3 letras..."
                                />
                                <div v-if="apoliceVinculoResults.length" class="mt-1 max-h-40 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-sm">
                                  <button
                                    v-for="item in apoliceVinculoResults"
                                    :key="item.id"
                                    type="button"
                                    @click="selecionarApoliceVinculo(item)"
                                    class="w-full text-left px-3 py-2 text-xs hover:bg-indigo-50 border-b border-gray-100 last:border-0"
                                  >
                                    {{ item.nome }} (No: {{ item.numero_apolice || item.id }})
                                  </button>
                                </div>
                                <p v-if="formVinculo.apolice_id" class="mt-1 text-xs text-green-600 font-semibold">
                                  ✓ Apólice selecionada: ID {{ formVinculo.apolice_id }}
                                </p>
                              </div>

                              <!-- Código do Certificado -->
                              <div>
                                <label class="block text-sm font-medium text-gray-700">Código do Certificado *</label>
                                <input
                                  type="text"
                                  v-model="formVinculo.codigo_certificado"
                                  class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-3 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                                  placeholder="Ex: CERT-998877"
                                />
                              </div>

                              <div class="grid grid-cols-2 gap-3">
                                <!-- Capital -->
                                <div>
                                  <label class="block text-sm font-medium text-gray-700">Capital (R$)</label>
                                  <input
                                    type="number"
                                    step="0.01"
                                    v-model="formVinculo.capital_atual"
                                    class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-3 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                                    placeholder="0.00"
                                  />
                                </div>
                                <!-- Prêmio -->
                                <div>
                                  <label class="block text-sm font-medium text-gray-700">Prêmio (R$)</label>
                                  <input
                                    type="number"
                                    step="0.01"
                                    v-model="formVinculo.valor_premio"
                                    class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-3 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                                    placeholder="0.00"
                                  />
                                </div>
                              </div>

                              <div class="grid grid-cols-2 gap-3">
                                <!-- Decesso -->
                                <div>
                                  <label class="block text-sm font-medium text-gray-700">Decesso (R$)</label>
                                  <input
                                    type="number"
                                    step="0.01"
                                    v-model="formVinculo.valor_decesso"
                                    class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-3 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                                    placeholder="0.00"
                                  />
                                </div>
                                <!-- Data Inclusão -->
                                <div>
                                  <label class="block text-sm font-medium text-gray-700">Data de Inclusão</label>
                                  <input
                                    type="date"
                                    v-model="formVinculo.data_inclusao"
                                    class="mt-1 block w-full rounded-md border border-gray-300 py-1.5 px-3 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                                  />
                                </div>
                              </div>

                              <!-- Seção de Beneficiários -->
                              <div class="pt-3 border-t border-gray-200">
                                <div class="flex items-center justify-between mb-2">
                                  <h4 class="text-sm font-semibold text-gray-800">Beneficiários</h4>
                                  <button
                                    type="button"
                                    @click="adicionarBeneficiarioVinculo"
                                    class="text-xs text-indigo-600 hover:text-indigo-800 font-semibold flex items-center gap-1"
                                  >
                                    + Adicionar Beneficiário
                                  </button>
                                </div>

                                <div v-if="!formVinculo.beneficiarios?.length" class="text-xs text-gray-400 italic mb-2">
                                  Nenhum beneficiário adicionado. Clique no botão acima para incluir.
                                </div>

                                <div
                                  v-for="(bene, index) in formVinculo.beneficiarios"
                                  :key="index"
                                  class="bg-gray-50 p-3 rounded-md border border-gray-200 mb-2 text-xs space-y-2 relative"
                                >
                                  <button
                                    type="button"
                                    @click="removerBeneficiarioVinculo(index)"
                                    class="absolute top-2 right-2 text-red-500 hover:text-red-700 font-bold"
                                    title="Remover"
                                  >
                                    ✕
                                  </button>

                                  <div class="grid grid-cols-2 gap-2">
                                    <div>
                                      <label class="block text-gray-700 font-medium mb-0.5">Nome *</label>
                                      <input
                                        type="text"
                                        v-model="bene.nome"
                                        class="w-full border border-gray-300 rounded px-2 py-1 text-xs focus:ring-indigo-500"
                                        placeholder="Nome do beneficiário"
                                      />
                                    </div>
                                    <div>
                                      <label class="block text-gray-700 font-medium mb-0.5">CPF</label>
                                      <input
                                        type="text"
                                        v-model="bene.cpf"
                                        class="w-full border border-gray-300 rounded px-2 py-1 text-xs focus:ring-indigo-500"
                                        placeholder="000.000.000-00"
                                      />
                                    </div>
                                  </div>

                                  <div class="grid grid-cols-2 gap-2">
                                    <div>
                                      <label class="block text-gray-700 font-medium mb-0.5">Parentesco</label>
                                      <input
                                        type="text"
                                        v-model="bene.grau_parentesco"
                                        class="w-full border border-gray-300 rounded px-2 py-1 text-xs focus:ring-indigo-500"
                                        placeholder="Ex: Cônjuge, Filho..."
                                      />
                                    </div>
                                    <div>
                                      <label class="block text-gray-700 font-medium mb-0.5">Participação (%)</label>
                                      <input
                                        type="number"
                                        step="0.01"
                                        v-model="bene.percentual_participacao"
                                        class="w-full border border-gray-300 rounded px-2 py-1 text-xs focus:ring-indigo-500"
                                        placeholder="100"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="mt-6 flex justify-end space-x-3">
                              <button
                                type="button"
                                @click="modalVincularAberto = false"
                                class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                              >
                                Cancelar
                              </button>
                              <button
                                type="button"
                                @click="salvarVinculoApolice"
                                :disabled="salvandoVinculo"
                                class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 disabled:opacity-50"
                              >
                                {{ salvandoVinculo ? 'Salvando...' : 'Salvar Vínculo' }}
                              </button>
                            </div>
                          </DialogPanel>
                        </TransitionChild>
                      </div>
                    </div>
                  </Dialog>
                </TransitionRoot>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
    </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import SolicitacaoForm from './SolicitacaoForm.vue';
import SolicistacoesList from './SolicistacoesList.vue';
import PropostaTimeline from './PropostaTimeline.vue';
import PropostaDocumentoUpload from './PropostaDocumentoUpload.vue';
import PropostaDocumentosPersonalizados from './PropostaDocumentosPersonalizados.vue';
import ApolicesRepository from '@/services/ApolicesRepository.vue';
import PropostasRepository from '@/services/PropostasRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import { pageVariables } from '@/views/insideviews/propostas/PageVariablesPropostas';
import debounce from 'lodash/debounce';
import Swal from "sweetalert2";
  export default {
    name: 'PropostasForm',
    emits: ['update-open', 'create-request', 'create-response', 'cancel-response-request', 'proposta-file', 'create-file', 'send-notification'],
    async created(){
      this.buscarApolices = debounce((...args) => {
        this._buscarApolices(...args);
      }, 400);
    },
    props: {
      title: {
        type: String,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      resetFormData:{
        type: Boolean,
        required:true
      },
      proposta:{
        type:Object,
        required:true
      }
    },  
    watch: {
      resetFormData(newValue) { 
        if(newValue == true){
          this.data = {}
        }
      }
    }, 
    data() {
      return {
        ...pageVariables,
        data:{},
        apoliceQuery: "",
        apoliceResults: [],
        apoliceTimer: null,
        solicitacaoOpen: false,
        tipoFormSolicitacao:'',
        solicitacaoId:'',
        modalDocumentoAberto:false,
        modalVincularAberto: false,
        salvandoVinculo: false,
        apoliceVinculoQuery: '',
        apoliceVinculoResults: [],
        formVinculo: {
          apolice_id: null,
          codigo_certificado: '',
          capital_atual: '',
          valor_premio: '',
          valor_decesso: '',
          data_inclusao: new Date().toISOString().substr(0, 10),
          is_dependente: false,
          tipo_vinculo: 0,
          dependente_id: null,
          dependente_nome: '',
          dependente_cpf: '',
          dependente_data_nascimento: '',
          dependente_rg: '',
          dependente_carreira: '',
          beneficiarios: []
        },
        apoliceData:{},
        onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
      };
    },
    computed: {
      isOnlyConsultor() {
        if (this.proposta && typeof this.proposta.is_only_consultor === 'boolean') {
          return this.proposta.is_only_consultor;
        }
        const groups = this.onlineUser?.groups || [];
        const adminGroups = ['master.justech', 'gcp-organization-admins', 'vida', 'admin', 'administradores'];
        const hasAdmin = groups.some(g => adminGroups.includes(g));
        const isConsultor = groups.includes('consultores');
        return isConsultor && !hasAdmin;
      }
    },
    methods: {
      closeDialog() {
        this.$emit('update-open', false);
      },
      openSolicitacao(tipo){
        this.tipoFormSolicitacao = tipo;
        this.solicitacaoOpen = true;
      },
      createResquest(data){
        this.$emit('create-request', data); 
      },
      createResponse(data){
        data.id = this.solicitacaoId;
        const payload = {
          id: this.solicitacaoId,
          proposta_id: data.proposta_id,
          resposta: data.resposta
        }
        this.$emit('create-response', payload); 
      },
      cancelRequest(data){
        data.id = this.solicitacaoId;
        console.log(data)
        const payload = {
          id: this.solicitacaoId,
          proposta_id: data.proposta_id,
          motivo_cancelamento: data.motivo_cancelamento
        }
        this.$emit('cancel-response-request', payload); 
      },
      getDoencaColorClass(doenca) {
        switch (doenca) {
          case 'Câncer':
            return 'bg-red-100 text-red-800';
          case 'Doença Cardíaca':
            return 'bg-blue-100 text-blue-800';
          case 'Diabetes':
            return 'bg-green-100 text-green-800';
          case 'HIV / Aids, Hepatite B ou C':
            return 'bg-pink-100 text-pink-800';
          case 'Doença Neurológica':
            return 'bg-purple-100 text-purple-800';
          case 'Transtorno Psiquiátrico':
            return 'bg-yellow-100 text-yellow-800';
          default:
            return 'bg-gray-100 text-gray-700';
        }
      },
      handleRequest(data){
        this.solicitacaoId = data.id;
        console.log(data)
        this.openSolicitacao(data.tipo)
      },
      enviarDocumentoProposta(data){
        const payload = {
          proposta_id: this.proposta.id,
          tipo_documento: data.tipo_documento,
          arquivo_base64: data.base64
        }
        this.$emit('proposta-file', payload);
      },
      notificar(){
        this.$emit('send-notification', this.proposta.id);
      },
      gerarDocumento(){
        this.$emit('create-file', this.proposta.id);
      },
      onSearchApolice() {
        this.data.apolice_id = null; 
        this.buscarApolices();
      },

      async _buscarApolices() {
        const q = (this.apoliceQuery || "").trim();

        if (q.length < 4) {
          this.apoliceResults = [];
          return;
        }

        const apolicesRepo = new ApolicesRepository();
        try {
          const response = await apolicesRepo.searchApolices(
            this.searchPage, 
            this.onlineUser.token,
            q
          );
         
          if (response?.status === 200) {
            this.apoliceResults = response.data || [];
          } else {
            this.apoliceResults = [];
            this.error = response?.message;
          }
          } catch (error) {
            this.apoliceResults = [];
            handleUnauthorized(error);
          }
        },

        selectApolice(item) {
          this.apoliceData.apolice_id = item.id;
          this.apoliceQuery = item.nome;
          this.apoliceResults = [];
          Swal.fire({
            icon: 'warning',
            title: 'Confirmar vínculo',
            text: 'Você tem certeza que quer vincular essa apólice à proposta?',
            showCancelButton: true,
            confirmButtonText: 'Sim, vincular',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#6b7280', // cinza (tailwind gray-500-ish)
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.vincularApolice();
            } else {
              // opcional: desfaz seleção se cancelar
              // this.data.apolice_id = null;
              // this.apoliceQuery = '';
            }
          });
        },

        async vincularApolice(){
          this.loading = true; 
          const apoliRepo = new ApolicesRepository();
          try {
            const response = await apoliRepo.apoliceSegurado(this.page,this.onlineUser.token,this.proposta.id,this.apoliceData);
            if (response?.status === 201) {
              this.mostrarAlerta();
              this.loading = false; 
            } else {
              this.error = response?.message;
              this.mostrarAlertaErro(this.error);
              this.loading = false;
            }
          } catch (error) {
            this.mostrarAlertaErro(error.message);
            handleUnauthorized(error);
            this.loading = false; 
          }	
        },
        mostrarAlerta() {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'A operação foi concluída com sucesso.',
            confirmButtonColor: '#3085d6', 
          });
        },

        mostrarAlertaErro(message) {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: message,
            confirmButtonColor: '#3085d6', 
          });
        },
        abrirModalVincularApolice() {
          const bens = (this.proposta?.beneficiarios || []).map(b => ({
            nome: b.nome || '',
            cpf: b.cpf || '',
            grau_parentesco: b.grau_parentesco || 'Não informado',
            percentual_participacao: b.percentual_participacao || 0
          }));

          const isDep = !!this.proposta?.dependente_id;
          const dep = this.proposta?.dependente;

          this.formVinculo = {
            apolice_id: this.proposta?.plan_id || this.proposta?.apolice_id || null,
            codigo_certificado: this.proposta?.apolice_numero || '',
            capital_atual: this.proposta?.capital || '',
            valor_premio: this.proposta?.premio_total || this.proposta?.premio_liquido || '',
            valor_decesso: '',
            data_inclusao: new Date().toISOString().substr(0, 10),
            is_dependente: isDep,
            tipo_vinculo: isDep ? 1 : 0,
            dependente_id: this.proposta?.dependente_id || null,
            dependente_nome: dep?.nome || '',
            dependente_cpf: dep?.cpf || '',
            dependente_data_nascimento: dep?.data_nascimento || '',
            dependente_rg: dep?.rg || '',
            dependente_carreira: dep?.carreira || '',
            beneficiarios: bens.length ? bens : [
              { nome: '', cpf: '', grau_parentesco: 'Cônjuge', percentual_participacao: 100 }
            ]
          };
          this.apoliceVinculoQuery = '';
          this.apoliceVinculoResults = [];
          this.modalVincularAberto = true;
        },

        adicionarBeneficiarioVinculo() {
          if (!this.formVinculo.beneficiarios) {
            this.formVinculo.beneficiarios = [];
          }
          this.formVinculo.beneficiarios.push({
            nome: '',
            cpf: '',
            grau_parentesco: 'Filho(a)',
            percentual_participacao: 0
          });
        },

        removerBeneficiarioVinculo(index) {
          if (this.formVinculo.beneficiarios) {
            this.formVinculo.beneficiarios.splice(index, 1);
          }
        },

        onSearchApoliceVinculo() {
          const q = (this.apoliceVinculoQuery || '').trim();
          if (q.length < 3) {
            this.apoliceVinculoResults = [];
            return;
          }
          const apolicesRepo = new ApolicesRepository();
          apolicesRepo.searchApolices(this.searchPage, this.onlineUser.token, q)
            .then(res => {
              if (res?.status === 200) {
                this.apoliceVinculoResults = res.data || [];
              }
            })
            .catch(() => {
              this.apoliceVinculoResults = [];
            });
        },

        selecionarApoliceVinculo(item) {
          this.formVinculo.apolice_id = item.id;
          this.apoliceVinculoQuery = `${item.nome} (${item.numero_apolice || item.id})`;
          this.apoliceVinculoResults = [];
        },

        async salvarVinculoApolice() {
          if (!this.formVinculo.apolice_id) {
            this.mostrarAlertaErro('Por favor, selecione uma apólice.');
            return;
          }
          if (!this.formVinculo.codigo_certificado) {
            this.mostrarAlertaErro('Por favor, informe o código do certificado.');
            return;
          }
          this.salvandoVinculo = true;
          const propostaRepo = new PropostasRepository();
          try {
            const response = await propostaRepo.vincularSegurado(
              this.onlineUser.token,
              this.proposta.id,
              this.formVinculo
            );
            if (response?.status === 200 || response?.status === 201) {
              this.salvandoVinculo = false;
              this.modalVincularAberto = false;
              this.mostrarAlerta();
              this.$emit('create-request', this.proposta.id);
            } else {
              this.salvandoVinculo = false;
              this.mostrarAlertaErro(response?.data?.mensagem || 'Erro ao vincular apólice.');
            }
          } catch (error) {
            this.salvandoVinculo = false;
            this.mostrarAlertaErro(error.response?.data?.mensagem || error.message);
          }
        },
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
      SolicitacaoForm,
      SolicistacoesList,
      PropostaTimeline,
      PropostaDocumentoUpload,
      PropostaDocumentosPersonalizados
    },
  }
</script>